module.exports = __webpack_public_path__ + "img/same-1.26328971.jpg";